import { isComponentReactFragment } from '../../../utils/react'

export function getFormikFieldInputErrorProps(error) {
  if (error === true) {
    return { showError: true }
  } else if (error) {
    return { errorText: error }
  } else {
    return {}
  }
}

export function getFormikFieldNextValue(value) {
  return value
}

export function getFormikFieldValueProps(field) {
  return {
    value: field.value,
  }
}

export function getFormikCheckboxFieldValueProps(field) {
  return {
    checked: field.value,
  }
}

export function getFormikCheckboxFieldErrorProps(error) {
  return error ? { hasError: !!error } : null
}

export function getFormikFieldContainerDisabledProps({ Field, disabled }) {
  return isComponentReactFragment(Field) ? null : { disabled }
}

export function getFormikFieldContainerValueProps({ Field, field }) {
  return isComponentReactFragment(Field) ? null : { value: field.value }
}
